import { MiniSearchBox } from 'src/Components/Atoms';
import Main from 'src/Layouts/Main'
import Head from 'next/head';
import favicon from "src/Resources/Images/favicon.ico";
import { useCallback, useEffect, useState } from 'react';
import Axios from 'axios';
import { YOUINVEST_DEVICE_TOKEN } from '../src/Api/YouInvest'

export default function Custom404() {
    const [nav, setNav] = useState(null);
    const [errorContent, setErrorContent] = useState(null);
    const title = '500 - Server-side error occurred';
    const getContent = useCallback(() => {
        return <div className="ajb-grid-row padding-top-10 padding-bottom-20">
            <div className="main-content-wrapper">
                <div className="ajb-grid-row margin-top-10">
                    <div className="ajb-col-12 ajb-col-8-breakpoint white-bg padding-top-20 padding-bottom-40">
                        <div className="ajb-grid-row padding-bottom-20">
                            <div className="card z-depth-0">
                                <div className="card-content">
                                    <h3>Sorry, there&apos;s a problem with the page you&apos;re looking for.</h3>
                                    <p className="h4 font-weight-thin grey-700-text">You can have another go at finding it by taking one of these steps:</p>
                                    <ul className="browser-default margin-bottom-30 margin-top-20" style={{ paddingLeft: "20px", marginTop: "10px", marginBottom: "15px" }}>
                                        <li className="max-characters-none" style={{ listStyleType: "disc", marginBottom: "8px" }}>
                                            If you&apos;ve entered the page&apos;s URL manually, please check it for typos.
                                        </li>
                                        <li className="max-characters-none" style={{ listStyleType: "disc", marginBottom: "8px" }}>
                                            Try navigating to it from our <a href={`/`}>homepage</a>
                                        </li>
                                        <li className="max-characters-none" style={{ listStyleType: "disc", marginBottom: "8px" }}>
                                            Enter the investment&apos;s name into the search bar below.
                                        </li>
                                    </ul>
                                    <h3>What investment are you looking for?</h3>
                                    <div className="ajb-col-4 ajb-col-8-breakpoint margin-top-20-sm padding-left-10-sm padding-right-0-sm"> {/* Column 4 of 12 Desktop : Column 8 of 8 Responsive */}
                                        <div>
                                            <MiniSearchBox />
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    }, []);
    const renderBasicErrorContent = useCallback(() => {
        return <>
            <Head>
                <title>{title}</title>
                <link rel="shortcut icon" href={favicon.src} type="image/x-icon" />
            </Head>
            {getContent()};
        </>;
    }, [getContent]);

    useEffect(() => {
        const fetchData = async () => {
            await Axios({
                method: 'GET',
                url: '/api/cms/navigations',
                headers: {
                    'Authorization': 'YouInvestDeviceToken token=' + YOUINVEST_DEVICE_TOKEN,
                    'X-Trading-Brand': 'trading'
                }
            }).then(response => {
                if (response.data.data) {
                    setNav(response.data.data);
                }
            }).catch(e => {
                console.error(e);
                setErrorContent(renderBasicErrorContent())
            });
        }

        fetchData();
    }, [renderBasicErrorContent]);

    useEffect(() => {
        if (nav) {
            const errorContentWithNav = <Main title={title} nav={nav} breadcrumb={title}>{getContent()}</Main>;
            setErrorContent(errorContentWithNav)
        }
    }, [nav, getContent]);


    return <>
        {errorContent}
    </>
}